import actionType from '../actions/storeStorage/actionType';

export interface lackGoodsListItem {
  qty: number;
  skuCode: string;
  skuName: string;
  storageQty: number;
}

export interface goodsStockItem {
  roomId?: number;
  storageId?: number;
  floorLocation?: string;
  roomNo?: string;
  mainStatus?: number;
  goodsStatus?: number;
  permanentQty?: number;
  qty?: number;
  lackQty?: number;
  lackGoodsList?: Array<lackGoodsListItem>;
  exceedQty?: number;
  exceedGoodsList?: Array<any>;
  allExceed?: boolean;
  allLack?: boolean;
}

export interface standardStockItem {
  floorLocation: string;
  permanentQty: number;
  roomId: number;
  roomNo: string;
  roomTypeName: string;
  storageId: number;
}
export interface standardStockRoomItem {
  skuCode: string;
  specValues: string;
  spuName: string;
  permanentQty: number;
}

interface StaffState {
  goodsStockList: Array<goodsStockItem>[];
  goodsStorageSummary: Object;
  searchValue: Object;
  goodsStockLoading: boolean;
  standardStockLoading: boolean;
  standardStockRoomLoading: boolean;
  standardStockList: Array<standardStockItem>[];
  standardStockRoomList: Array<standardStockRoomItem>[];
}

const initialState: StaffState = {
  goodsStorageSummary: {
    lackQty: null,
    totalQty: null,
    shopQty: null,
    receptionQty: null,
    totalPermanentQty: null,
  },
  goodsStockList: [],
  standardStockList: [],
  standardStockRoomList: [],
  searchValue: {
    goodsStatus: null,
    skuCode: null,
  },
  goodsStockLoading: false,
  standardStockLoading: false,
  standardStockRoomLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GET_GOODS_STOCK_LIST:
      return {
        ...state,
        goodsStockList: [...action.payload.goodsStockList],
      };
    case actionType.GET_GOODS_STORAGE_SUMMARY:
      return {
        ...state,
        goodsStorageSummary: {
          ...state.goodsStorageSummary,
          ...action.payload,
        },
      };
    case actionType.GET_STANDARD_STOCK_ROOM_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.GET_STANDARD_STOCK_LIST:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: {
          ...state.searchValue,
          ...action.payload,
        },
      };
    default:
      return {
        ...state,
        ...action.payload,
      };
  }
};
